import { render, staticRenderFns } from "./RewardsFloatingButton.vue?vue&type=template&id=3853463b&scoped=true&"
import script from "./RewardsFloatingButton.vue?vue&type=script&lang=js&"
export * from "./RewardsFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./RewardsFloatingButton.vue?vue&type=style&index=0&id=3853463b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3853463b",
  null
  
)

export default component.exports